window.addEventListener("DOMContentLoaded", () => {
  /**
   * 画像遅延読み込み
   * <img data-src="xxx.png" data-src-state>
   */
  const load_img_src = (element) => {
    element.addEventListener("load", (e) => {
      e.target.dataset.srcState = "loaded";
    });
    element.src = element.dataset.src;
  };
  document.querySelectorAll("img[data-src]").forEach((element) => {
    /* data-intersection属性がある場合 */
    if (element.hasAttribute("data-intersection")) {
      element.addEventListener("intersection", (event) => {
        if (
          "loaded" != element.dataset.srcState &&
          "true" == element.dataset.intersectionState
        ) {
          load_img_src(event.target);
        }
      });
      return;
    }
    /* 画像読み込み */
    load_img_src(element);
  });

  /**
   * 背景画像遅延読み込み
   * data-bg-img-src="xxx.png" data-src-state
   */
  const load_bg_img = (element) => {
    const src = element.dataset.bgImgSrc;
    const img = new Image();
    img.addEventListener("load", (event) => {
      element.dataset.srcState = "loaded";
    });
    img.src = src;
    element.style.backgroundImage = `url(${src})`;
  };
  document.querySelectorAll("[data-bg-img-src]").forEach((element) => {
    /* data-intersection属性がある場合 */
    if (element.hasAttribute("data-intersection")) {
      element.addEventListener("intersection", (event) => {
        if (
          "loaded" != element.dataset.srcState &&
          "true" == element.dataset.intersectionState
        ) {
          load_bg_img(event.target);
        }
      });
      return;
    }
    /* 背景画像読み込み */
    load_bg_img(element);
  });
});
